export const blockIconsTravelSportsBarNew = (
	<span className='material-symbols-outlined'>sports_bar</span>
);
